import { useEffect, useState } from 'react';

// Typed access to window.cookieConsent from public/consent.js, which owns the cookie banner.

export type ConsentCategory = 'analytics' | 'marketing';

export interface ConsentState {
  decided: boolean;
  analytics: boolean;
  marketing: boolean;
}

interface CookieConsentApi {
  get: () => ConsentState;
  onChange: (fn: (state: ConsentState) => void) => () => void;
  open: () => void;
}

declare global {
  interface Window {
    cookieConsent?: CookieConsentApi;
  }
}

/** Calls fn with the visitor's choice now (if made) and on every change. Returns an unsubscribe. */
export function onCookieConsent(fn: (state: ConsentState) => void): () => void {
  const api = window.cookieConsent;
  if (!api) return () => undefined;
  return api.onChange(fn);
}

export function hasCookieConsent(category: ConsentCategory): boolean {
  return window.cookieConsent?.get()[category] === true;
}

/** Re-renders when the visitor changes their cookie choice. False until they allow the category. */
export function useCookieConsent(category: ConsentCategory): boolean {
  const [allowed, setAllowed] = useState(false);
  useEffect(() => onCookieConsent((state) => setAllowed(state[category])), [category]);
  return allowed;
}
